import * as React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

function OrderRowListSkeleton() {
    return (
        <div className="col-sm-12">
            <div className="panel panel-default">
                <div className="panel-heading">
                    <Skeleton variant="text" width={160} height={24} />
                </div>
                <div className="panel-body">
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <Skeleton variant="rectangular" width="100%" height={32} />
                        <Skeleton variant="rectangular" width="100%" height={40} />
                        <Skeleton variant="rectangular" width="100%" height={40} />
                        <Skeleton variant="rectangular" width="100%" height={40} />
                    </Box>
                    <div className="row">
                        <div className="col-sm-12 col-md-6">
                            <Box sx={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
                                <Skeleton variant="rectangular" width="60%" height={34} />
                                <Skeleton variant="rectangular" width={120} height={34} />
                            </Box>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderRowListSkeleton;
